import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ModalService, TranslateLoader } from '@cfp/core';
import { ChartDataTableSidePanel, ChartDataTableSidePanelData } from '@cfp/ui';
// eslint-disable-next-line import/no-restricted-paths -- Roadmap is in domains, we should investigate how we can move it to features-shared
import { RoadmapChart, RoadmapChartUsage, RoadmapModule } from '@cfp/domains/roadmap';
import { RoadmapService } from '@cfp/shared/roadmap';
import { BuildingDetailsDTO, RoadmapBuildingDetailsDTO } from 'csr-asset-app';
import { map } from 'rxjs';

@Component({
  selector: 'cfp-building-report-graphs',
  templateUrl: 'building-report-graphs.html',
  imports: [RoadmapModule, RoadmapChart, RoadmapChartUsage],
  providers: [CurrencyPipe, DecimalPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuildingReportGraphs {
  public readonly roadmapBuildingDetailsFromInput = input<RoadmapBuildingDetailsDTO>(undefined, {
    alias: 'roadmapBuildingDetails'
  });
  public readonly showGraphs = input<boolean>(false);
  public readonly building = input.required<BuildingDetailsDTO>();

  private readonly modalService = inject(ModalService);
  private readonly roadmapService = inject(RoadmapService);
  private readonly translateLoader = inject(TranslateLoader);

  protected readonly isTranslationLoaded = toSignal(
    this.translateLoader.loadTranslation('roadmap').pipe(map(() => true))
  );

  protected readonly roadmapBuildingDetails = computed(() => {
    const roadmapBuildingDetails = this.roadmapBuildingDetailsFromInput();
    if (!roadmapBuildingDetails) {
      return undefined;
    }
    const years = roadmapBuildingDetails.years.filter((year) => year.investment).map((year) => year.year);

    const startYear = this.roadmapService.getStartYear(years);
    const endYear = this.roadmapService.getEndYear(years);
    roadmapBuildingDetails.years = roadmapBuildingDetails.years.filter(
      (year) => year.year && year.year >= startYear && year.year <= endYear
    );
    return roadmapBuildingDetails;
  });

  protected onShowData(data: ChartDataTableSidePanelData): void {
    this.modalService.showSidePanel(ChartDataTableSidePanel, { data: data });
  }
}
